import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import CustomLoader from '../shared/CustomLoader';
import SettingsForm from '../forms/SettingsForm';
import { addSettings, allSettings } from '../../services/settings';
import { handleError } from '../../utilities/errorHandler';

const Settings = () => {
  const [settings, setSettings] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({
    text: '',
    variant: '',
    show: false
  });

  const handleMessage = (text, variant) => {
    setMessage(createMessage(text, variant));
  }

  const handleCloseMessage = () => {
    setMessage((prevMessage) => ({...prevMessage, show: false}));
  }

  const getSettings = useCallback( async () => {
    setIsLoading(true);
    try {
      const response = await allSettings();
      if (response.status === 200){
        setSettings(response.data);
      }
    } catch (error) {
      const errorMessage = handleError(error);
      if (errorMessage){
        handleMessage(errorMessage.text, 'danger');
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  const settingsObject = settings.reduce((acc, setting) => {
    acc[setting.key] = setting.value;
    return acc;
  }, {});

  useEffect(() => {
    getSettings();
  }, [getSettings]);

  const saveSettings = async (formData) => {
    setIsSaving(true);
    try {
      // Call the update service 
      await addSettings(formData);
      handleMessage('Settings successfully saved', 'success');

      return true;
    } catch (error) {
      console.error('Error occurred', error);
      try {
        const errorMessage = handleError(error);
        if (errorMessage){
          handleMessage(errorMessage.text, 'danger');
        }
      } catch (e) {
        throw e
      }
    } finally {
      await new Promise((resolve) => setTimeout(resolve, 500));
      setIsSaving(false);
    }
  }

  return (
    <Container fluid>

      <PageTitle title='Settings' />

      <Message
        message={message.text}
        variant={message.variant}
        handleClose={handleCloseMessage}
        show={message.show}
      />

      {
        isLoading ? (
          <CustomLoader />
        ) : (
          <SettingsForm
            formAction={saveSettings}
            setting={settingsObject}
            isSaving={isSaving}
          />

        )
      }
    </Container>
  )
}

export default Settings